<template>
    <layout>
        <RegulationList
            :moduleId="moduleCode"
            id="regulations"
            :addItemTitle="`regulations.list.buttons.item`"
            columnParentId="regulation_id"
        />

    </layout>
</template>

<script>
    import GeneralMixin from '../../mixin'

    export default {
        mixins: [
            GeneralMixin
        ],
        components: {
            RegulationList: () => import(/* webpackChunkName: "grouped-links-list" */ '@/app/shared/components/grouped_links/List'),
        },
    }
</script>

<style scoped lang="scss">

</style>
